export enum ModelIdEnum {
  // Text to Video
  TEXT_TO_VIDEO_Kling_v2_6_Pro = 13,
  TEXT_TO_VIDEO_Seedance_v1_5_Pro = 15,
  TEXT_TO_VIDEO_Sora_2_Pro = 1,
  TEXT_TO_VIDEO_Veo_3_1 = 3,
  TEXT_TO_VIDEO_Kling_2_5_Turbo_Pro = 5,

  // Image to Video
  IMAGE_TO_VIDEO_Kling_v2_6_Pro = 14,
  IMAGE_TO_VIDEO_Seedance_v1_5_Pro = 16,
  IMAGE_TO_VIDEO_Sora_2_Pro = 2,
  IMAGE_TO_VIDEO_Veo_3_1 = 4,
  IMAGE_TO_VIDEO_Kling_2_5_Turbo_Pro = 6,

  // Text to Image
  TEXT_TO_IMAGE_Nano_Banana_Pro = 11,
  TEXT_TO_IMAGE_Flux_Kontext_Pro = 9,

  // Image to Image
  IMAGE_TO_IMAGE_Nano_Banana_Pro = 12,
  IMAGE_TO_IMAGE_Flux_Kontext_Pro = 10,

  // Video Edit
  VIDEO_EDIT_Kling_v2_6_Pro_Motion_Control = 18,
  VIDEO_EDIT_Kling_O1_Video_Edit = 17,
}
